<!--  Toolbar (main navigation) -->
<mat-toolbar class="toolbar" role="navigation">
    <div class="toolbar__logo-wrapper">
        <img class="toolbar__logo" alt="Scope Logo" src="assets/icons/scope-logo.svg" />

        <!-- show badge color -->
        @if (!checkEnvironmentName('prod')) {
            <span
                class="riege-badge"
                [class.badge--dev]="checkEnvironmentName('local') || checkEnvironmentName('dev')"
                [class.badge--staging]="checkEnvironmentName('staging')"
                selected
                >{{ title }}</span
            >
        }
    </div>

    <!-- spacer -->
    <span class="toolbar__spacer"></span>
</mat-toolbar>
